import { render } from "./RaisedHandIcon.vue?vue&type=template&id=8ab53156&scoped=true"
const script = {}

import "./RaisedHandIcon.vue?vue&type=style&index=0&id=8ab53156&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab53156"]])

export default __exports__